module.exports = __webpack_public_path__ + "img/old-logo (2).1265ec3e.png";